import angularRedux from '@buildium/angular-redux';
import buildInfo from '../../build-info.json';

const isProduction = window.location.host.indexOf('managebuilding.com') !== -1;

export const ManagerGlobalStateModule = angularRedux.createModule('buildium.manager.global-state', [])
    .constant('IS_DEBUGGING_ENABLED', buildInfo.isDebuggingEnabled)
    .constant('IS_PRODUCTION', isProduction);
